import { toast } from "react-toastify";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _single, _WorkActivityRelationGroup } from "../../../../core/services/dataBean/EntityCatalog";
import { useEffect } from "react";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import useModal, { MODAL_md, MODAL_SM } from "../../../theme/Component/hooks/useModal";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { SelectWorkActivityGroup } from "../../WorkActivityGroup/SelectWorkActivityGroup";
import usePaginator from "../../../theme/Component/usePaginator";

type WorkgroupActivity = {
    IDSprint: number;
    [key: string]: any;
}

interface Props {
    Sprint: WorkgroupActivity;
}

export const WorkActivityRelationGroup = ({ Sprint }: Props) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_WorkActivityRelationGroup);
    const paginador = usePaginator();

    const modal = useModal("", MODAL_md);
    const modalC = useModal("Eliminar grupo del periodo", MODAL_SM);

    useEffect(() => {
        if (Sprint.IDSprint) {
            getLista();
        }
    }, [Sprint, paginador.page])

    const getLista = () => {
        const props = {
            IDSprint: Sprint.IDSprint,
            State: 1,
        }
        instance.getWorkActivityRelationRender(paginador.page, 15, props).then(
            (resp) => {
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * (15));
                paginador.setRegiPerPage(15)
                setLista(resp.List);
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const head = [
        { title: 'ID', property: 'IDWorkActivityRelationGroup', visible: true },
        { title: 'Grupo', property: 'GroupName', visible: true },
        { title: 'Fecha de Asignacion', property: 'FromDate', visible: true },
        { title: 'Fecha de Finalizacion', property: 'UptoDate', visible: true },
    ];

    const create = () => {
        setBean({
            FromDate: _single.getCurrenDate(),
            State: 1,
            IDSprint: Sprint.IDSprint
        });
        modal.open("Agregar grupo a Periodo de Tiempo")
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalC.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const deleteItem = () => {
        const x = { ...bean, State: 101, UptoDate: _single.getCurrenDate() };
        editaItem(x);
    };

    const editaItem = (obj: any) => {
        instance.updateWorkActivityRelationGroup(obj).then(
            (resp: any) => {
                getLista();
                modal.close();
                modalC.close()
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable iconButtons={iconButtonsItem} listButtons={listaBotones()} body={lista} head={head} rowSet={setBean} />

                <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { editaItem(bean) }}>
                    <div className="row">
                        <div className="col-md-12">
                            <SelectWorkActivityGroup idSelector={bean.IDWorkActivityGroup} onChange={(e) => { setBean({ ...bean, IDWorkActivityGroup: e }) }} />
                        </div>
                    </div>
                </Modal>

                <ModalConfirm modal={modalC.modal} updateModal={modalC.setModal} eventModal={deleteItem}>
                    <strong>Eliminar item {bean.GroupName}</strong>
                </ModalConfirm>

            </div>
        </div>
    )
}